// Splits the server's `tip_rates` payload into the shape both donation
// widgets consume. Shared so the wire format has exactly one parser:
// v7 wraps this in donate_v7/parseTipping (which adds the tipping-type
// booleans), v6 calls it from its pack entry and adds its own
// 'both' → 'tipping' mapping.
//
// Two rate schemes come over the same key. `auto` (dynamic) carries a
// `matrix` string, one row per donation band:
//
//   5000 1 0.03 0.05 0.07
//   20 1 0.1 0.15 0.2
//   15 2 1 2 3
//
// — threshold, then the index of that row's default option, then the
// options themselves. Rows are matched top-down by first threshold the
// amount clears, so they must stay in descending order. Options are
// interpreted by magnitude (lt 1 a fraction of the donation, gte 1 a
// fixed amount); utils/tipOptions owns that rule and the labels.
//
// Everything else on `tip_rates` falls into `fixed`, which becomes the
// whole config under the non-auto scheme ({ default, options }).
// `zero_option` is pulled out separately precisely because of that: it
// applies to both schemes, so it can't live inside the object that only
// describes one of them.
const parseTipRates = tipRates => {
  // `|| {}` rather than a default parameter, matching utils/tipOptions: a
  // default only fires on undefined, and this guards a value read out of a
  // JSONB column. Unreachable today — _config.erb deep_merges a
  // `tip_rates: { default: ... }` into every payload, so the widget can't
  // receive a non-Hash here — but the tolerance is free and the asymmetry
  // would be a trap.
  const { matrix, auto, zero_option: zeroTip, ...fixed } = tipRates || {}
  const configs = auto ? matrix?.split(/\n+/).map(row => {
    const [ threshold, defaultIndex, ...options ] = row.split(/\s+/)
    return { threshold, default: options[defaultIndex], options }
  }) : null

  return { auto, fixed, configs, zeroTip }
}

export default parseTipRates
